export const CloseIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 4L4 20M4 4L20 20" stroke-width="2" stroke-linecap="round" />
    </svg>
  );
};
